export interface PipeStrokePreset {
  id: string
  label: string
  diameter: number
  color: string
}

export const PIPE_STROKE_PRESETS: PipeStrokePreset[] = [
  { id: 'small', label: '小口径', diameter: 0.2, color: '#9ca3af' },
  { id: 'medium', label: '中口径', diameter: 0.35, color: '#9ca3af' },
  { id: 'large', label: '大口径', diameter: 0.5, color: '#9ca3af' },
]

export function getPipePresetById(id: string): PipeStrokePreset {
  return PIPE_STROKE_PRESETS.find(p => p.id === id) ?? PIPE_STROKE_PRESETS[1]!
}
